import { Localization } from "@qubictron/localization";
import { qubictronUrlMap } from "@qubictron/url";
import { IS_APP_IN_IFRAME } from "shared/constants/common.constants";
import { assets } from "shared/utils/url.utils";

const localeUrlBuilder = assets.locales.translationFileBuilder();
if (IS_APP_IN_IFRAME) {
  localeUrlBuilder.setOrigin(qubictronUrlMap.prod().origin);
}

const l = new Localization({
  backendLoadPath: localeUrlBuilder.build(),
});

export const localization = l.getInstance();

export const changeLanguage = l.changeLanguage.bind(l);

export const t = localization.t.bind(localization);

export { LocalizationProvider, useTranslation } from "@qubictron/localization";
